import { mapActions, mapState } from 'vuex'

/**
 * Handle check out submit action
 */
export default {
  props: {
    /**
     * Url to redirect the user after a successful submit
     */
    redirectUrl: {
      type: String
    },
  },
  computed: {
    ...mapState('spaSoft', ['isSpaLoading'])
  },
  watch: {
    isSpaLoading(val) {
      this.isLoading = val
      this.form.find('input, select, textarea').prop('disabled', val)
      this.$emit('loading', val)
    }
  },
  methods: {
    ...mapActions('spaSoft', ['spaCheckoutAction']),
    submitAction(data) {
      return this.spaCheckoutAction(data)
    },
  }
}
